<template>
  <div class="tumeng-valuation-edit">
    <el-tabs :stretch="true" value="style">
      <el-tab-pane
        :label="$t('lcd.Editor.Style')"
        name="style"
        class="style-pane"
      >
        <attr-row
          :label="$t('lcd.Editor.Layer Name') + ' : ' + conf.name"
        ></attr-row>
        <attr-row :label="$t('lcd.Editor.Position and Size')">
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.left"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeX"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">X</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.top"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeY"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">Y</div>
              </template>
            </el-input>
          </div>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.width"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeW"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">W</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.height"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeH"
            >
              <template slot="prepend"
                ><div style="width: 12px; text-align: center">H</div></template
              >
            </el-input>
          </div>
        </attr-row>
        <attr-row :label-width="0" class="custom-smaller-btn">
          <el-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Left')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.textAlign === 'flex-start' ? 'primary' : ''"
                @click="changeTA('flex-start')"
              >
                <i
                  class="icon iconfont icon-zuoduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Center in Horizontal')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.textAlign === 'center' ? 'primary' : ''"
                @click="changeTA('center')"
              >
                <i
                  class="icon iconfont icon-chuizhijuzhong"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Right')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.textAlign === 'flex-end' ? 'primary' : ''"
                @click="changeTA('flex-end')"
              >
                <i
                  class="icon iconfont icon-youduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align to Top')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.verticalAlign === 'flex-start' ? 'primary' : ''"
                @click="changeVA('flex-start')"
              >
                <i
                  class="icon iconfont icon-shangduiqi"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align Center in Vertical')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.verticalAlign === 'center' ? 'primary' : ''"
                @click="changeVA('center')"
              >
                <i
                  class="icon iconfont icon-shuipingjuzhong"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Align to Bottom')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.verticalAlign === 'flex-end' ? 'primary' : ''"
                @click="changeVA('flex-end')"
              >
                <i
                  class="icon iconfont icon-xiaduiqi"
                  style="font-size: 12px"
                ></i>
              </el-button>
            </el-tooltip>
          </el-button-group>
          <div style="height: 5px"></div>
          <div v-if="!pageColor" style="display: flex; align-items: center">
            <i
              class="icon iconfont icon-zitiyanse"
              style="font-size: 12px; margin-right: 6px; color: #000"
            ></i>
            <el-color-picker
              v-model="conf.fontColor"
              show-alpha
              :predefine="predefineColors"
              size="mini"
            />
            <i
              class="icon iconfont icon-beijingse"
              style="font-size: 12px; margin: 0 6px 0 18px; color: #000"
            ></i>
            <el-color-picker
              v-model="conf.bgColor"
              show-alpha
              :predefine="predefineColors"
              size="mini"
            />
            <i
              class="icon iconfont icon-shezhipingji"
              style="font-size: 12px; margin: 0 6px 0 18px; color: #000"
            ></i>
            <el-color-picker
              v-model="conf.iconColor"
              show-alpha
              :predefine="predefineColors"
              size="mini"
            />
          </div>

          <!-- 价签字体颜色 -->
          <div
            class="EditorEslColorList"
            v-if="pageColor"
            style="display: flex; align-items: center"
          >
            <i
              class="icon iconfont icon-zitiyanse"
              style="font-size: 12px; margin-right: 6px; color: #000"
            ></i>
            <i v-for="(c, index) in colorList" :key="c.id">
              <span
                v-if="c.flag.includes(pageColor)"
                @click="changeFontColor(index)"
                class="colorLi"
                :style="{ background: c.color }"
              ></span>
            </i>
          </div>
          <!-- 价签填充色 -->
          <div
            class="EditorEslColorList"
            v-if="pageColor"
            style="display: flex; align-items: center"
          >
            <i
              class="icon iconfont icon-beijingse"
              style="font-size: 12px; margin-right: 6px; color: #000"
            ></i>
            <i v-for="(c, index) in colorList" :key="c.id">
              <span
                v-if="c.flag.includes(pageColor)"
                @click="changeBgColor(index)"
                class="colorLi"
                :style="{ background: c.color }"
              ></span>
            </i>
            <img @click="conf.bgColor = 'rgba(0,0,0,0)'" :src="transparentBg" style="width: 18px;height:18px;">
          </div>
          <!-- 价签评级颜色 -->
          <div
            class="EditorEslColorList"
            v-if="pageColor"
            style="display: flex; align-items: center"
          >
            <i
              class="icon iconfont icon-shezhipingji"
              style="font-size: 12px; margin: 0 6px 0 0; color: #000"
            ></i>
            <i v-for="(c, index) in colorList" :key="c.id">
              <span
                v-if="c.flag.includes(pageColor)"
                @click="changeIconColor(index)"
                class="colorLi"
                :style="{ background: c.color }"
              ></span>
            </i>
          </div>
        </attr-row>
        <attr-row
          v-if="goodsFields"
          :label="$t('lcd.Editor.Data Format')"
          class="th dir"
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <el-input
              v-model="conf.preText"
              :placeholder="$t('lcd.Editor.preText')"
              size="mini"
              style="width: 49%"
            />
            <el-select
              v-model="conf.datasetField"
              size="mini"
              clearable
              filterable
              :placeholder="$t('lcd.Editor.Please Select Data Field')"
              style="display: block; width: 49%"
            >
              <el-option
                v-for="field in goodsFields"
                :key="field.value"
                :label="field.label"
                :value="field.value"
                :disabled="field.type != 'number'"
              />
            </el-select>
          </div>
        </attr-row>

        <!-- <attr-row
          v-if="goodsFields"
          :label="$t('lcd.Editor.Score Type')"
          class="th dir"
        >
          <el-select
            v-model="conf.valuationType"
            size="mini"
            clearable
            placeholder="$t('lcd.Editor.Please select the score type')"
            style="display: block"
          >
            <el-option value="0" label="1-5分制">1-5分制</el-option>
            <el-option value="1" label="1-10分制">1-10分制</el-option>
            <el-option value="2" label="百分比制">百分比制</el-option>
          </el-select>
        </attr-row> -->
        <!-- <attr-row label="数值显示">
          <el-checkbox v-model="conf.showData" />
        </attr-row> -->
        <!-- 前缀样式 -->
        <attr-row
          class="custom-smaller-btn"
          :label="$t('lcd.Editor.Pre Font Style')"
        >
          <el-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Bold')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.preTextStyle.isBold ? 'primary' : ''"
                @click="handleClickBold('preTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitijiacu"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Font Italic')"
              placement="top"
            >
              <el-button
                size="small"
                :type="conf.preTextStyle.isItaly ? 'primary' : ''"
                @click="handleClickItaly('preTextStyle')"
              >
                <i
                  class="icon iconfont icon-xieti"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Underline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="
                  conf.preTextStyle.isUnderline === 'underline' ? 'primary' : ''
                "
                @click="handleClickUnderline('preTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitixiahuaxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Deleteline')"
              placement="top"
            >
              <el-button
                size="small"
                :type="
                  conf.preTextStyle.isUnderline === 'line-through'
                    ? 'primary'
                    : ''
                "
                @click="handleClickDeleteline('preTextStyle')"
              >
                <i
                  class="icon iconfont icon-zitishanchuxian"
                  style="font-size: 12px; height: 12px; line-height: 12px"
                ></i>
              </el-button>
            </el-tooltip>
          </el-button-group>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-select
              v-model="conf.preTextStyle.font"
              :placeholder="$t('lcd.Editor.Font Family')"
              size="mini"
              style="width: 49%"
            >
              <el-option
                v-for="item in allFontList"
                :key="item"
                :label="item"
                :value="item"
                :style="{ fontFamily:item }"
              />
            </el-select>
            <!-- 字体大小 -->
            <el-select
              v-model="conf.preTextStyle.fontSize"
              size="mini"
              filterable
              allow-create
              default-first-option
              :placeholder="$t('lcd.Editor.Font Size')"
              style="width: 49%"
            >
              <el-option
                v-for="item in fontSizeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </attr-row>

        <!-- 图标样式 -->
        <attr-row
          :label="$t('lcd.Editor.Icon Style')"
          class="custom-color-picker"
        >
          <div id="myOwnButton">
            <el-select
              v-model="conf.fontSize"
              size="mini"
              filterable
              allow-create
              default-first-option
            >
              <el-option
                v-for="item in fontSizeList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <el-radio-group v-model="conf.iconStyle" size="mini">
              <el-radio-button label="el-icon-star-on">
                <i class="el-icon-star-on" style="font-size: 16px" />
              </el-radio-button>
              <!-- <el-radio-button label="el-icon-s-opportunity">
              <i class="el-icon-s-opportunity" style="font-size: 18px" />
            </el-radio-button>
            <el-radio-button label="el-icon-success">
              <i class="el-icon-success" style="font-size: 18px" />
            </el-radio-button>
            <el-radio-button label="el-icon-sugar">
              <i class="el-icon-sugar" style="font-size: 18px" />
            </el-radio-button> -->
            </el-radio-group>
          </div>
        </attr-row>

        <attr-row
          :label="$t('lcd.Editor.Rotate')"
          :height="38"
          class="custom-smaller-slider-btn2"
        >
          <div style="padding: 0 0 0 8px">
            <el-slider v-model="conf.rotate" :min="0" :max="360" />
            <el-input-number
              v-model="conf.rotate"
              controls-position="right"
              :min="0"
              :max="360"
              size="mini"
            />
          </div>
        </attr-row>

        <!-- 显示逻辑 -->
        <attr-row
          :label="$t('lcd.Editor.isShow')"
          class="tt"
          style="position: relative"
        >
          <el-radio-group v-model="conf.hide">
            <el-radio size="mini" :label="true">{{
              $t("lcd.Editor.hide text")
            }}</el-radio>
            <el-radio size="mini" :label="false">{{
              $t("lcd.Editor.show text")
            }}</el-radio>
          </el-radio-group>
          <!-- {{conf.showLogic}} -->
          <el-button
            class="logicBtn"
            type="text"
            size="mini"
            @click.native="showLogicDialog"
            >{{ $t("lcd.Editor.show logic") }}</el-button
          >
        </attr-row>
      </el-tab-pane>
    </el-tabs>
    <LogicDialog
      :logicDetail="conf.showLogic"
      ref="logicRef"
      @getLogic="getLogic"
    ></LogicDialog>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import AttrRow from "../../tumeng-attr-row/src/index.vue";
import LogicDialog from "../../tumeng-display/src/index.vue";
import transparentBg from "../../../assets/imgs/icon-tr-bg.png";
import {
  fontSizeList,
  fontList,
  predefineColors,colorList,
} from "../../../utils/constant";

export default {
  name: "TumengValuationEdit",
  props: {
    goodsFields: {
      type: Array,
      default: [],
    },
    userFontList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    AttrRow,
    LogicDialog,
  },
  computed: {
    conf() {
      return store.state.activeComponent;
    },
    pageColor() {
      return store.state.programInfo.color ? store.state.programInfo.color : "";
    },
    // fields() {
    //   let fields = null;
    //   if (store.state.programInfo.templateGroupId == 0) {
    //     fields = store.state.programInfo.goodsFields
    //   }
    //   if (fields) {
    //     return fields;
    //   }
    //   return undefined;
    // },
  },
  data() {
    return {
      transparentBg,
      predefineColors,
      colorList,
      allFontList: Array.from(new Set ([...fontList,...JSON.parse(localStorage.getItem('userFontList'))])),
      fontSizeList,
      canvasWidth: store.state.programInfo.width,
      canvasHeight: store.state.programInfo.height,
    };
  },
  methods: {
    changeRangeX(e) {
      console.log("X", e);
      console.log(this.canvasWidth, this.canvasHeight);
      let confX = +e;
      if (confX > this.canvasWidth - this.conf.width) {
        confX = this.canvasWidth - this.conf.width;
      }
      if (confX < 0) {
        confX = 0;
      }
      this.conf.left = parseInt(confX);
    },
    changeRangeY(e) {
      let confY = +e;
      if (confY > this.canvasHeight - this.conf.height) {
        confY = this.canvasHeight - this.conf.height;
      }
      if (confY < 0) {
        confY = 0;
      }
      this.conf.top = parseInt(confY);
    },
    changeRangeW(e) {
      let confW = +e;
      if (confW > this.canvasWidth - this.conf.left) {
        confW = this.canvasWidth - this.conf.left;
      }
      if (confW < 0) {
        confW = 0;
      }
      this.conf.width = parseInt(confW);
    },
    changeRangeH(e) {
      let confH = +e;
      if (confH > this.canvasHeight - this.conf.top) {
        confH = this.canvasHeight - this.conf.top;
      }
      if (confH < 0) {
        confH = 0;
      }
      this.conf.height = parseInt(confH);
    },
    changeTA(ta) {
      this.conf.textAlign = ta;
    },
    changeVA(va) {
      this.conf.verticalAlign = va;
    },
    handleClickBold() {
      this.conf.preTextStyle.isBold = !this.conf.preTextStyle.isBold;
    },
    handleClickItaly() {
      this.conf.preTextStyle.isItaly = !this.conf.preTextStyle.isItaly;
    },
    handleClickDirection() {
      this.conf.preTextStyle.editDirection =
        !this.conf.preTextStyle.editDirection;
    },
    handleClickUnderline() {
      const text =
        this.conf.preTextStyle.isUnderline === "underline"
          ? "none"
          : "underline";
      this.conf.preTextStyle.isUnderline = text;
    },
    handleClickDeleteline() {
      const text =
        this.conf.preTextStyle.isUnderline === "line-through"
          ? "none"
          : "line-through";
      this.conf.preTextStyle.isUnderline = text;
    },
    showLogicDialog() {
      this.$refs.logicRef.open();
      console.log(12333333);
    },
    getLogic(val) {
      console.log(val);
      this.conf.showLogic = val;
    },

    // 修改字体颜色
    changeFontColor(index) {
      this.conf.fontColor = this.colorList[index].color;
    },
    // 修改文本填充色背景色
    changeBgColor(index) {
      this.conf.bgColor = this.colorList[index].color;
    },
    // changeIconColor
    changeIconColor(index) {
      this.conf.iconColor = this.colorList[index].color;
    },
  },
};
</script>

<style scoped lang="scss">
.tumeng-valuation-edit {
  margin: 8px;
  .style-pane {
    // 时长样式
    .duration {
      div.el-input-number {
        width: 100%;
      }

      ::v-deep span.el-input-number__decrease,
      ::v-deep span.el-input-number__increase {
        display: none;
      }

      ::v-deep input.el-input__inner {
        padding: 0 15px;
        text-align: justify;
      }
    }

    // 横纵坐标、宽高样式
    @import "../../../assets/style/ltwh";
    // 加粗、倾斜、下划线那一行按钮变小
    .custom-smaller-btn {
      ::v-deep button.el-button {
        padding: 5px 11px;
      }
    }

    // 行高的样式
    .custom-smaller-slider-btn {
      // 拖拽点变小
      ::v-deep .el-slider__button {
        border-width: 1px;
        width: 10px;
        height: 10px;
      }

      // 指定slider宽度
      ::v-deep .el-slider {
        width: calc(100% - 66px);
        margin-right: 16px;
        float: left;
      }

      // 隐藏数字控制按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }

      // 隐藏数字输入框的padding
      ::v-deep div.el-input-number div.el-input > input.el-input__inner {
        padding: 0;
      }

      // 指定输入框的宽度
      ::v-deep .el-input-number {
        width: 50px;
        float: left;
        margin-top: 5px;
      }
    }

    // 旋转的样式
    .custom-smaller-slider-btn2 {
      // 拖拽点变小
      ::v-deep .el-slider__button {
        border-width: 1px;
        width: 10px;
        height: 10px;
      }

      // 指定slider宽度
      ::v-deep .el-slider {
        width: calc(100% - 76px);
        margin-right: 16px;
        float: left;
      }

      // 隐藏数字控制按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }

      // 隐藏数字输入框的padding
      ::v-deep div.el-input-number div.el-input > input.el-input__inner {
        padding: 0;
      }

      // 指定输入框的宽度
      ::v-deep .el-input-number {
        width: 60px;
        float: left;
        margin-top: 5px;
      }
    }

    .custom-color-picker {
      ::v-deep span.el-color-picker__icon.el-icon-arrow-down {
        display: none;
      }

      ::v-deep div.el-color-picker__trigger {
        border: none;
      }
    }

    // 滚动方向
    .dir {
      .el-radio {
        margin-right: 5px;

        ::v-deep .el-radio__label {
          padding-left: 2px;
        }
      }
    }
  }
  .explain {
    line-height: 30px;
  }
}
::v-deep .el-tabs__item.is-active {
  background-color: #f5f7fa;
  border-radius: 5px 5px 0 0;
}

.logicBtn {
  position: absolute;
  top: 0px;
  right: -15px;
  z-index: 101;
  &.el-button.el-button--mini {
    font-size: 12px;
  }
}
</style>
<style>
#myOwnButton .el-radio-button--mini .el-radio-button__inner {
  padding: 5px;
  margin-left: 8px;
}
</style>